import PropTypes from "prop-types";

export default PropTypes.shape({
  jobType: PropTypes.string.isRequired,
});
